var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCheckCircle(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "check-circle-1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "M10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20C15.5228 20 20 15.5228 20 10C19.9936 4.47982 15.5202 0.00642897 10 0Z",
    fill: "#3FA268",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M15.7722 6.83337L10.068 14.5742C9.93197 14.7547 9.72912 14.873 9.50503 14.9024C9.28094 14.9319 9.05441 14.8701 8.87634 14.7309L4.80301 11.4742C4.44356 11.1866 4.38536 10.662 4.67301 10.3025C4.96066 9.94309 5.48523 9.88489 5.84468 10.1725L9.24134 12.89L14.4305 5.84754C14.6007 5.5922 14.8974 5.45103 15.2029 5.48007C15.5083 5.50912 15.7731 5.70368 15.8921 5.98652C16.0111 6.26935 15.965 6.59469 15.7722 6.83337Z",
    fill: "#3FA268"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckCircle);
export default __webpack_public_path__ + "static/media/check-circle.e8648ec84a442ef68d506791dcb9160f.svg";
export { ForwardRef as ReactComponent };